<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminSeckillOrder.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="adminSeckillOrderInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input :placeholder="$t('adminSeckillOrder.orderIdPlaceholder')"
                v-model="adminSeckillOrderInfo.conditions.orderId" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('adminSeckillOrder.prodNamePlaceholder')"
                v-model="adminSeckillOrderInfo.conditions.prodName" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('adminSeckillOrder.buyerNamePlaceholder')"
                v-model="adminSeckillOrderInfo.conditions.buyerName" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryAdminSeckillOrderMethod()">
                <i class="el-icon-search"></i>
                {{ $t('adminSeckillOrder.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminSeckillOrder.seckillOrder') }}</span>
          </div>
          <el-table :data="adminSeckillOrderInfo.orders" style="width: 100%" border stripe>
            <el-table-column prop="orderId" :label="$t('adminSeckillOrder.orderId')" align="center">
            </el-table-column>
            <el-table-column :label="$t('adminSeckillOrder.productImage')" align="center">
              <template slot-scope="scope">
                <el-image style="width: 50px; height: 50px; border-radius: 10px;" :src="scope.row.coverPhoto"
                  :preview-src-list="[scope.row.coverPhoto]" fit="cover">
                  <div slot="error" class="image-slot">
                    <img width="50" height="50" style="border-radius: 10px;" src="/img/noPhoto.jpg">
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="prodName" :label="$t('adminSeckillOrder.productName')" align="center">
            </el-table-column>
            <el-table-column prop="buyerName" :label="$t('adminSeckillOrder.buyer')" align="center">
            </el-table-column>
            <el-table-column prop="goodsNum" :label="$t('adminSeckillOrder.quantity')" align="center">
            </el-table-column>
            <el-table-column prop="killPrice" :label="$t('adminSeckillOrder.seckillPrice')" align="center">
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('adminSeckillOrder.purchaseTime')" align="center">
            </el-table-column>
            <el-table-column prop="state" :label="$t('adminSeckillOrder.status')" align="center">
              <template slot-scope="scope">
                {{ scope.row.state == 'C' ? $t('adminSeckillOrder.completed') : $t('adminSeckillOrder.pendingPayment')
                }}
              </template>
            </el-table-column>
            <el-table-column prop="endTime" :label="$t('adminSeckillOrder.deadline')" align="center">
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="adminSeckillOrderInfo.conditions.page"
            :page-size="adminSeckillOrderInfo.conditions.row" layout="total, prev, pager, next"
            :total="adminSeckillOrderInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminSeckillOrder } from '@/api/group/adminSeckillOrderApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  components: {
    AdminShop
  },
  data() {
    return {
      adminSeckillOrderInfo: {
        orders: [],
        total: 0,
        conditions: {
          orderId: '',
          prodName: '',
          buyerName: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAdminSeckillOrders(1, 10)
  },
  methods: {
    handleShopChange(shop) {
      this.adminSeckillOrderInfo.conditions.shopId = shop.shopId
      this._listAdminSeckillOrders(1, 10)
    },
    handleCurrentChange(val) {
      this._listAdminSeckillOrders(val, this.adminSeckillOrderInfo.conditions.row)
    },
    async _listAdminSeckillOrders(page, row) {
      this.adminSeckillOrderInfo.conditions.page = page
      this.adminSeckillOrderInfo.conditions.row = row
      try {
        const res = await queryAdminSeckillOrder(this.adminSeckillOrderInfo.conditions)
        this.adminSeckillOrderInfo.orders = res.data
        this.adminSeckillOrderInfo.total = res.total
      } catch (error) {
        console.error('获取秒杀订单失败:', error)
      }
    },
    _queryAdminSeckillOrderMethod() {
      this._listAdminSeckillOrders(1, 10)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.box-card {
  margin-bottom: 20px;
}
</style>